import React from "react";
import css from "./Badge.module.css";


export default function Badge(props){
    const {text}=props;
    return (
        <span 
            {...props}
            className={`${css.badge} ${props.className||""}`}
        >{text}</span>
    )
}
